<template>
    <detalhe titulo="Status" :size="size">
        <status :status="demandaExpress?.statusDescr"></status>
    </detalhe>
    <detalhe titulo="Recebido em" :size="size">
        {{ $dateFormat(demandaExpress?.dataRegistro, 'DD/MM/YYYY HH:mm:ss') }}
    </detalhe>
    <detalhe titulo="Projeto" :size="size">
        {{ demandaExpress?.nomeProjeto }}
    </detalhe>
    <detalhe titulo="Integrado em" :size="size" v-if="demandaExpress?.dataIntegracao">
        {{ $dateFormat(demandaExpress?.dataIntegracao, 'DD/MM/YYYY HH:mm:ss') }}
    </detalhe>
    <detalhe titulo="Atualizado em" :size="size">
        {{ $dateFormat(demandaExpress?.dataAtualizacao, 'DD/MM/YYYY HH:mm:ss') }}
    </detalhe>
</template>

<script>
export default {
    props: {
        demandaExpress: {
            type: Object,
        },
    },

    data() {
        return {
            size: '100',
        };
    },
};
</script>
